import { render } from "./AppInputAddon.vue?vue&type=template&id=d5f9f782&ts=true"
import script from "./AppInputAddon.vue?vue&type=script&lang=ts"
export * from "./AppInputAddon.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/wVusKqw4/1/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__